import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React, { Fragment } from "react";

export function withSnackbar(Component) {
  return class WithSnackbar extends Component {
    state = {
      message: "",
      open: false,
      duration: 6000,
      severity: "success",
      position: {
        vertical: "top",
        horizontal: "right",
      },
    };
    showMessage = (
      message,
      severity = "success",
      duration = 6000,
      position = "top-right"
    ) => {
      const [vertical, horizontal] = position.split("-");
      this.setState({
        message,
        severity,
        duration,
        open: true,
        position: {
            vertical,
            horizontal
        }
      });
    };

    handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      this.setState({
        open: false,
      });
    };

    render() {
      const {
        open,
        duration,
        severity,
        message,
        position: { vertical, horizontal },
      } = this.state;
      return (
        <Fragment>
          <Component {...this.props} showMessage={this.showMessage} />
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={duration}
            onClose={this.handleClose}
            style={{
              fontFamily: "inherit",
            }}
          >
            <Alert
              onClose={this.handleClose}
              severity={severity}
              sx={{ width: "100%" }}
              style={{
                fontFamily: 'inherit'
              }}
            >
              {message}
            </Alert>
          </Snackbar>
        </Fragment>
      );
    }
  };
}
